module.exports = __webpack_public_path__ + "static/media/hipkar-logo-text.bee87436.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/hipkar-logo-text.png
// module id = 120
// module chunks = 0